var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import moment from 'moment-timezone';
var timeFormat = 'h:mm a';
var OrderizableTypes;
(function (OrderizableTypes) {
    OrderizableTypes["APPOINTMENT"] = "appointment";
    OrderizableTypes["ADDON_SERVICE"] = "addon_service";
    OrderizableTypes["PRODUCT"] = "product";
    OrderizableTypes["CUSTOM"] = "custom";
})(OrderizableTypes || (OrderizableTypes = {}));
export var convertToAvailability = function (dates, timeZone) {
    return dates.map(function (date) { return moment.tz(date, timeZone); });
};
export var convertToDateSlots = function (dtos, timeZone, requestedSlots) {
    return dtos.reduce(function (slots, slotsDate) { return __spreadArray(__spreadArray([], slots, true), [
        {
            date: moment.tz(slotsDate.date, timeZone),
            slots: convertToSlots(slotsDate, timeZone, requestedSlots),
        },
    ], false); }, []);
};
export var convertToSlots = function (dto, timeZone, requested) {
    var responded = (dto.available_hours || []).map(function (hour) {
        var _a, _b;
        return ({
            time: moment.tz(hour.datetime, timeZone),
            title: hour.time,
            availableStaffIds: __spreadArray([], ((_a = hour.staff_available) !== null && _a !== void 0 ? _a : []), true),
            unavailableStaffIds: __spreadArray([], ((_b = hour.staff_unavailable) !== null && _b !== void 0 ? _b : []), true),
        });
    });
    var notResponded = requested.filter(function (req) { return !responded.some(function (resp) { return resp.time.format(timeFormat) === req.format(timeFormat); }); });
    return __spreadArray(__spreadArray([], responded, true), notResponded.map(function (time) { return ({
        time: time,
        title: time.format(timeFormat),
        availableStaffIds: [],
        unavailableStaffIds: [],
    }); }), true).sort(function (slot, otherSlot) { return slot.time.valueOf() - otherSlot.time.valueOf(); });
};
export var convertToPetService = function (dto) { return ({
    service: {
        id: dto.service_id,
        name: dto.service_name,
    },
    price: dto.price,
    durationInMinutes: dto.duration,
}); };
export var convertToNewBookingAlerts = function (dtos) {
    return dtos.map(function (dto) { var _a; return ({ alertType: dto.alert_type, message: dto.message, error: (_a = dto.error) !== null && _a !== void 0 ? _a : false }); });
};
export var convertToOrderizableType = function (type) {
    switch (type) {
        case OrderizableTypes.APPOINTMENT:
            return "Appointment";
        case OrderizableTypes.PRODUCT:
            return "BusinessProduct";
        case OrderizableTypes.ADDON_SERVICE:
            return "AddonService";
        default:
            return null;
    }
};
